export default "__VITE_ASSET__124ca2a9__"